export default __webpack_public_path__ + "static/media/1856.09176def.png";